<template>
  <v-row class="justify-space-between">
    <v-col sm="12" class="px-2">
      <v-row>


        <v-data-table dense :headers="headerLibretaNotas" :items="dataAreasEval" class="transparent elevation-0 my-4"
          hide-default-header :items-per-page="15">
          <template #header="{ }">
            <thead class="v-data-table-header">
              <tr>
                <th v-for="(h, i) in headerLibretaNotas" :key="i" :class="h.class" :rowspan="h.periodo ? 1 : 2"
                  :colspan="h.periodo ? listPeriodo.length : 1">
                  {{ h.text }}
                </th>
              </tr>
              <tr>
                <th v-for="(h1, i1) in listPeriodo" :key="i1" class="text-center black--text">
                  {{ h1.nombre_periodo }}
                </th>
                <th v-if="listPeriodo.length != 0" class="text-center black--text bg-compArea">
                  COMPETENCIA
                </th>
                <th v-if="listPeriodo.length != 0" class="text-center black--text bg-compArea">
                  ÁREA
                </th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="{ item }">
            <tr class="styleBorder">
              <td style="
                            border-left: solid 1px #e0e0e0;
                            border-right: solid 1px #e0e0e0;
                            " :rowspan="item.evaluacion ? item.evaluacion.length + 1 : 1">
                <strong> {{ item.desc_area.toUpperCase() }} </strong>
              </td>
            </tr>
            <tr class="styleBorder" v-for="(child, index) in item.evaluacion"
              :key="`${item.evaluacion[index].id_competencia}${item.id}`">
              <td :style="index == 0 ? 'border-top: solid 1px #e0e0e0' : ''">
                <i>{{ child.competencia }} </i>
              </td>
              <td :style="index == 0 ? 'border-top: solid 1px #e0e0e0' : ''" class="ChildstyleBorder" v-for="(c, ci) in obtenerFilasCompetencias(
                child.periodo,
                item.id
              )" :key="ci">
                <strong style="color: green" v-if="c == 4"> AD </strong>
                <strong style="color: blue" v-else-if="c == 3"> A </strong>
                <strong style="color: brown" v-else-if="c == 2"> B </strong>
                <strong style="color: red" v-else-if="c == 1"> C </strong>
                <strong v-else> {{ c }} </strong>
                <!-- <span> {{ c }} </span> -->
              </td>
              <td v-if="index == 0" style="background: #fdeec1" :rowspan="item.evaluacion ? item.evaluacion.length : 1">
                <strong style="color: green" v-if="promCompetencia(item) == 4">
                  AD
                </strong>
                <strong style="color: blue" v-else-if="promCompetencia(item) == 3">
                  A
                </strong>
                <strong style="color: brown" v-else-if="promCompetencia(item) == 2">
                  B
                </strong>
                <strong style="color: red" v-else-if="promCompetencia(item) == 1">
                  C
                </strong>
                <strong v-else> {{ promCompetencia(item) }} </strong>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import {  mapGetters } from "vuex";
let _ = require("lodash");


export default {
  name: 'LibretaDelEstudiante',
  props: ["dataAreasEval", "listPeriodo"],
  components: {},



  data() {
    return {

      headerLibretaNotas: [
        {
          text: "ÁREAS",
          align: "start",
          sortable: false,
          value: "id",
          class: "secondary black--text text-center",
        },
        {
          text: "COMPETENCIAS",
          value: "desc_area",
          class: "secondary black--text text-center",
        },
        {
          text: "NIVEL DE LOGRO POR PERIODO",
          value: "evaluacion",
          divider: true,
          periodo: [
            { text: "PERIODO 1" },
            { text: "PERIODO 2" },
            { text: "PERIODO 3" },
            { text: "PERIODO 4" },
          ],
          class: "secondary black--text text-center bg-nivelPeriodos",
        },
        {
          text: "NIVEL DE LOGRO FINAL",
          value: "promedio",
          divider: true,
          periodo: [{ text: "COMPETENCIA " }, { text: "ÁREA" }],
          class: "secondary black--text text-center bg-nivelLogroFinal",
        },
      ],


      headerAreaCompetencias: [
        {
          text: "AREAS",
          align: "start",
          sortable: false,
          value: "id",
          class: "secondary black--text text-center",
        },
        {
          text: "COMPETENCIAS",
          value: "desc_area",
          class: "secondary black--text text-center",
        },
        {
          text: "CONCLUSIÓN DESCRIPTIVA",
          value: "conclusion",
          class: "secondary black--text text-center bg-nivelPeriodos",
        },
      ],
      dataAreasCom: [],




    };
  },

  methods: {



    obtenerFilasCompetencias(rows, idx) {
      let cont = 0;
      let sumar = 0;
      let nota;
      const result = {};
      _.forEach(rows, (key, index2) => {
        if (key.nota_alumno) {
          cont++;
          nota = key.nota_alumno;
          result["c" + index2] = key.nota_alumno.toFixed();
          sumar += nota;
        } else {
          result["c" + index2] = "-";
        }
      });

      result["competencia" + idx] = (sumar / cont).toFixed();

      return result;
    },


    promCompetencia(item) {
      let suma = 0;
      if (item.evaluacion) {
        item.evaluacion.forEach((evalItem) => {
          suma +=
            this.obtenerFilasCompetencias(evalItem.periodo, item.id)[
            "competencia" + item.id
            ] / item.evaluacion.length;
        });
      }
      return suma.toFixed();
    },




  },



  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    totals() {
      let totals = {};
      // TOTAL
      // console.log(this.listPeriodo);
      this.listPeriodo.forEach((periodo) => {
        totals[periodo.nombre_periodo] = 0;
      });
      this.dataAreasEval.forEach((area) => {
        if (area.evaluacion) {
          area.evaluacion.forEach((evaluacion) => {
            evaluacion.periodo.forEach((p) => {
              if (p.nota_alumno) {
                totals[p.nombre_periodo] += p.nota_alumno / 3;
              }
            });
          });
        }
      });
      return totals;
    },
  },


}
</script>
